export default __webpack_public_path__ + "static/media/gallery_12.3f06c31b.jpg";